var form = {
    basic_array: [
        {
            key:'是否孕妇',
            value:'否',
            must:1,
            options:[
                '是',
                '否'
            ]
        },{
            key:'饮食',
            value:'正常',
            must:0,
            options:[
                '正常',
                '量少',
                '量多'
            ]
        },{
            key:'睡眠',
            value:'正常',
            must:0,
            options:[
                '正常',
                '失眠',
                '嗜睡'
            ]
        },{
            key:'大便',
            value:'正常',
            must:0,
            options:[
                '正常',
                '泄泻',
                '便秘'
            ]
        },{
            key:'小便',
            value:'正常',
            must:0,
            options:[
                '正常',
                '憋尿',
                '尿频'
            ]
        },
    ],
    basic_enter_array: [
        {
            key:'体温',
            value:'',
            must:0,
        },
        {
            key:'脉搏',
            value:'',
            must:0,
        },
        {
            key:'收缩压',
            value:'',
            must:0,
        },
        {
            key:'舒张压',
            value:'',
            must:0,
        },
        {
            key:'主诉',
            value:'',
            must:0,
        },
        {
            key:'诊断结果',
            value:'',
            must:0,
        }
    ],
    maixiang_array: [
        {
            key: '左手寸脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
        {
            key: '左手关脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
        {
            key: '左手尺脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
        {
            key: '右手寸脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
        {
            key: '右手关脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
        {
            key: '右手尺脉',
            value: '正常',
            must:1,
            options: [
            '正常',
            '不及',
            '太过'
            ]
        },
    ],
    shangjiao_array: [
        {
            key:'上官头',
            value:[],
            options:[
                '眩晕',
                '头痛',  
            ]
        },
        {
            key: '上官眼',
            value: [],
            options: [
                '眼干',
                '口眼歪斜',
                '畏光',
            ]
        },
        {
            key: '上官耳',
            value: [],
            options: [
                '耳病'
            ]
        },
        {
            key: '上官鼻',
            value: [],
            options: [
                '鼻炎'
            ]
        },
        {
            key: '上官口',
            value: [],
            options: [
                '口苦',
                '口疮',
            ]
        },
        {
            key: '上官牙',
            value: [],
            options: [
                '牙痛'
            ]
        },
        {
            key: '颈项上肢咽喉',
            value: [],
            options: [
                '颈椎病',
                '手臂疼痛',
                '手臂伸屈不利',
                '咽干',
                '食管炎',
                '反酸',
                '肩周炎',
            ]
        },
        {
            key: '肺',
            value: [],
            options: [
                '上焦积聚',
                '甲状腺结节',
                '感冒',
                '发烧',
                '乳腺结节',
                '气管炎',
                '哮喘',
                '咳嗽',
                '痰多',
                '肺部积聚',
                '多汗',
                '畏风',
            ]
        },
        {
            key: '心脑',
            value: [],
            options: [
                '心悸',
                '胸闷气短',
                '心梗阻',
                '心律不齐',
                '心绞痛',
                '脑血栓',
            ]
        },
        {
            key: '其他',
            value: [],
            options: [
                '火旺',
                '出血',
            ]
        }
    ],
    zhongjiao_array: [
        {
            key: '胃',
            value: [],
            options: [
                '胃寒',
                '胃胀',
                '胃炎',
                '胃息肉',
                '胃肿瘤',
            ]
        },
        {
            key: '肝胆',
            value: [],
            options: [
                '肝囊肿',
                '肝血管瘤',
                '肝肿瘤',
                '脂肪肝',
                '肝硬化',
                '肝腹水',
                '胆囊炎',
                '胆息肉',
                '胆结石',
            ]
        },
        {
            key: '三高',
            value: [],
            options: [
                '高血脂',
                '高血糖',
                '高血压',
                '低血压', 
            ]
        },
        {
            key: '胸肋背',
            value: [],
            options: [
                '胸椎不适',
                '胁肋疼痛',
                '背部疼痛',
            ]
        },
        {
            key: '其他',
            value: [],
            options: [
                '湿气重',
                '胰腺炎',
                '出血',
            ]
        },
    ],
    xiajiao_array: [
        {
            key: '肾膀胱',
            value: [],
            options: [
                '肾结石',
                '肾炎',
                '肾囊肿',
                '尿毒症',
                '膀胱结石',
                '尿贮留',
                '尿路感染',
                '前列腺炎',
                '尿频',
                '腹内积聚',
                '疝气',
            ]
        },
        {
            key: '妇科',
            value: [],
            options: [
                '月经不调',
                '痛经',
                '子宫肌瘤',
                '卵巢囊肿',
            ]
        },
        {
            key: '腰膝',
            value: [],
            options: [
                '腰痛',
                '坐骨神经痛',
                '下肢沉重',
                '左膝关节不利',
                '右膝关节不利',
                '股骨头坏死',
            ]
        },
        {
            key: '其他',
            value: [],
            options: [
                '痔疮',
                '痛风',
                '结肠炎',
                '火旺',
                '出血',
                '畏寒',
            ]
        },
    ],
}
export default form


// WEBPACK FOOTER //
// ./src/js/form.js